"use strict";

jQuery(document).ready(function ($) {
  //   const isDebug = false;
  const prodInfoContainerClass = ".product__info-container";
  const bundleProdInfoClass = ".biscuits-bundle-summary__info";

  const cloneSquarePlacement = () => {
    const selector = ".shopify-block.shopify-app-block:has(square-placement)";
    const targetSelector = ".biscuits-bundle-summary__actions .biscuits-bundle-summary__buttons";
    const performClone = ($original) => {
      const $target = $(targetSelector);
      if ($original.length && $target.length && !$original.hasClass("original-hidden")) {
        const $cloned = $original.clone(true, true);
        $cloned.addClass("cloned-square-placement");
        $cloned.insertAfter($target);
        $original.addClass("original-hidden").hide();
        return true;
      }
      return false;
    };

    const $existingOriginal = $(selector);
    const $existingTarget = $(targetSelector);
    if ($existingOriginal.length && $existingTarget.length) {
      performClone($existingOriginal);
    } else {
      const observer = new MutationObserver((mutations, obs) => {
        const $original = $(selector);
        const $target = $(targetSelector);
        if ($original.length && $target.length) {
          if (performClone($original)) {
            obs.disconnect();
          }
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  };

  const cloneBundleToggle = () => {
    const selector = ".biscuits-bundle-summary .biscuits-bundle-summary__content button.biscuits-bundle-summary__toggle";
    const targetSelector = "#biscuits-bundle-summary";

    const performClone = ($original) => {
      const $target = $(targetSelector);
      if ($original.length && $target.length && !$(".cloned-bundle-toggle").length) {
        const $cloned = $original.clone(true, true);
        $cloned.addClass("cloned-bundle-toggle");

        $cloned.on("click", function (e) {
          e.preventDefault();
          $original[0].click();
        });

        $cloned.insertBefore($target);
        return true;
      }
      return false;
    };

    const $existingOriginal = $(selector);
    const $existingTarget = $(targetSelector);
    if ($existingOriginal.length && $existingTarget.length) {
      performClone($existingOriginal);
    } else {
      const observer = new MutationObserver((mutations, obs) => {
        const $original = $(selector);
        const $target = $(targetSelector);
        if ($original.length && $target.length) {
          if (performClone($original)) {
            obs.disconnect();
          }
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  };

  /**
   * Converts the original progress-bar style volume discounts layout
   * into a dynamic thumbnails layout based on parsed tiers and max quantity.
   */
  const renderVolumeDiscountThumbnails = () => {
    if (!$(".biscuits-bundle-volume-discounts").length) return;

    const $container = $(".biscuits-bundle-volume-discounts");
    const $inner = $(".biscuits-bundle-volume-discounts__inner").first();

    if ($container.length && $inner.length) {
      const tiers = [];
      $container.find("biscuits-bundle-volume-discount-tier").each(function () {
        const $tier = $(this);
        const qty = parseInt($tier.attr("data-biscuits-quantity"), 10);
        const type = $tier.attr("data-biscuits-discount-type") || "vp";
        const val = $tier.attr("data-biscuits-discount-value") || "";
        const amount =
          $tier.find("[data-biscuits-discount-amount]").first().attr("data-biscuits-discount-amount") ||
          $tier.find(".biscuits-bundle-volume-discount__progress [data-biscuits-discount-amount]").first().text() ||
          (val ? val + "%" : "");
        const isLast = $tier.hasClass("biscuits-bundle-volume-discount-tier--last");

        tiers.push({
          qty: qty,
          type: type,
          val: val,
          amount: amount,
          isLast: isLast,
        });
      });

      let maxQty = 0;
      const $bar = $container.find(".biscuits-bundle-volume-discount__bar");
      if ($bar.length) {
        const ariaMax = parseFloat($bar.attr("aria-valuemax"));
        if (!isNaN(ariaMax)) {
          maxQty = Math.round(ariaMax);
        }
      }

      const placeholdersCount = $("#biscuits-summary-condensed .biscuits-bundle-summary__products .biscuits-bundle-summary__placeholder").length;
      if (placeholdersCount > maxQty) {
        maxQty = placeholdersCount;
      }

      if (maxQty <= 0) {
        tiers.forEach((t) => {
          if (t.qty > maxQty) maxQty = t.qty;
        });
      }
      maxQty <= 0 && (maxQty = 5);

      const $originalTitle = $container.find(".biscuits-bundle-volume-discounts__title");
      const titleHtml = $originalTitle.length ? $originalTitle.html() : "";

      let itemsHtml = "";
      for (let q = 1; q <= maxQty; q++) {
        const tier = tiers.find((t) => t.qty === q);
        if (tier) {
          const isLastClass = tier.isLast ? " biscuits-bundle-volume-discount-tier--last" : "";
          itemsHtml += `
        <biscuits-bundle-volume-discount-tier class="biscuits-bundle-volume-discount-tier biscuits-bundle-volume-discount-tier--milestone${isLastClass}"
            data-biscuits-quantity="${q}" data-biscuits-discount-type="${tier.type}" data-biscuits-discount-value="${tier.val}" tabindex="0"
            aria-labelledby="biscuits-volume-discount-title--${q}">
            <span id="biscuits-volume-discount-title--${q}" class="biscuits--sr-only">${q} for <span data-biscuits-discount-amount="${tier.amount}">${tier.amount}</span> off</span> 
            <span class="biscuits-bundle-volume-discount__badge" aria-hidden="true">
                <span class="biscuits-bundle-volume-discount__success">
                    <span data-biscuits-discount-amount="${tier.amount}">${tier.amount}</span> OFF
                </span>
            </span>
            <div class="biscuits-bundle-volume-discount__card" aria-hidden="true">
                <span class="biscuits-bundle-volume-discount__progress">
                    <span data-biscuits-discount-amount="${tier.amount}">${tier.amount}</span><br>OFF
                </span> 
                <span class="biscuits-bundle-volume-discount__quantity">${q}</span>
                <span class="biscuits-bundle-volume-discount__product"></span>
            </div>
        </biscuits-bundle-volume-discount-tier>`;
        } else {
          itemsHtml += `
        <div class="biscuits-bundle-volume-discount-tier" data-biscuits-quantity="${q}" aria-hidden="true">
            <div class="biscuits-bundle-volume-discount__card">
                <span class="biscuits-bundle-volume-discount__quantity">${q} </span><span class="biscuits-bundle-volume-discount__product"></span>
            </div>
        </div>`;
        }
      }

      $container.attr("data-biscuits-style", "thumbnails");

      $inner.html(`<div class="biscuits-bundle-volume-discounts__inner">
    <h3 id="biscuits-volume-discounts" class="biscuits-bundle-volume-discounts__title">
        ${titleHtml}
    </h3>
    <p class="biscuits-bundle-volume-discounts__unlocked-message"></p>
    <span id="biscuits-volume-discount-notification" class="biscuits-volume-discount-notification biscuits--sr-only" aria-live="polite"></span>
    <div class="biscuits-bundle-volume-discounts__container" data-biscuits-item-count="${maxQty}">
        ${itemsHtml}
    </div>
</div>`);

      // Re-bind properties on the custom element instance once it is defined in the browser registry.
      customElements.whenDefined("biscuits-bundle-volume-discounts").then(() => {
        const el = $container[0];
        if (el) {
          el.displayStyle = "thumbnails";
          el.volumeDiscountTiers = el.querySelectorAll(".biscuits-bundle-volume-discount-tier");
          el.volumeDiscountTitle = el.querySelector(".biscuits-bundle-volume-discounts__title");
          el.a11yNotification = el.querySelector(".biscuits-volume-discount-notification");
          if (el.volumeDiscountTitle) {
            el.quantityContainers = el.volumeDiscountTitle.querySelectorAll("[data-biscuits-discount-quantity]");
            el.discountAmountContainers = el.volumeDiscountTitle.querySelectorAll("[data-biscuits-discount-amount]");
            el.countLeftContainers = el.volumeDiscountTitle.querySelectorAll("[data-biscuits-count-left]");
          }

          // Patch handleSelectionUpdate to show/hide the unlocked discount message
          const originalHandleSelectionUpdate = el.handleSelectionUpdate;
          el.handleSelectionUpdate = function () {
            // Dynamically sync the number of thumbnails with the placeholders count
            const currentPlaceholdersCount = $("#biscuits-summary-condensed .biscuits-bundle-summary__products .biscuits-bundle-summary__placeholder").length;
            const baseMaxQty = maxQty > 0 ? maxQty : 5;
            const targetCount = Math.max(baseMaxQty, currentPlaceholdersCount);
            const currentTiers = el.querySelectorAll(".biscuits-bundle-volume-discount-tier");
            const currentTiersCount = currentTiers.length;

            if (targetCount > currentTiersCount) {
                const $tiersContainer = $(el).find(".biscuits-bundle-volume-discounts__container");
                for (let q = currentTiersCount + 1; q <= targetCount; q++) {
                    const newTierHtml = `
                    <div class="biscuits-bundle-volume-discount-tier" data-biscuits-quantity="${q}" aria-hidden="true">
                        <div class="biscuits-bundle-volume-discount__card">
                            <span class="biscuits-bundle-volume-discount__quantity">${q} </span><span class="biscuits-bundle-volume-discount__product"></span>
                        </div>
                    </div>`;
                    $tiersContainer.append(newTierHtml);
                }
                el.volumeDiscountTiers = el.querySelectorAll(".biscuits-bundle-volume-discount-tier");
                $tiersContainer.attr("data-biscuits-item-count", targetCount);
            } else if (targetCount < currentTiersCount) {
                const $tiersContainer = $(el).find(".biscuits-bundle-volume-discounts__container");
                for (let q = targetCount; q < currentTiersCount; q++) {
                    $(currentTiers[q]).remove();
                }
                el.volumeDiscountTiers = el.querySelectorAll(".biscuits-bundle-volume-discount-tier");
                $tiersContainer.attr("data-biscuits-item-count", targetCount);
            }

            if (typeof originalHandleSelectionUpdate === "function") {
              originalHandleSelectionUpdate.apply(this, arguments);
            }

            const sortedTiers = [...tiers].sort((a, b) => b.qty - a.qty);
            const maxTier = sortedTiers[0];
            const maxTierQty = maxTier ? maxTier.qty : baseMaxQty;
            const maxDiscountAmount = maxTier ? maxTier.amount : "";

            const $unlockedMsg = $inner.find(".biscuits-bundle-volume-discounts__unlocked-message");
            if (this.totalItemsQuantity >= maxTierQty && maxDiscountAmount) {
              $unlockedMsg.text(`Savings ${maxDiscountAmount}`).show();
            } else {
              $unlockedMsg.hide();
            }
          };

          if (typeof el.handleSelectionUpdate === "function") {
            el.handleSelectionUpdate();
          }
        }
      });
    }
  };

  (function () {
    renderVolumeDiscountThumbnails();

    cloneSquarePlacement();
    cloneBundleToggle();

    if ($(prodInfoContainerClass).length) {
      const $shippingNote = $(`${prodInfoContainerClass} .biscuits-shipping-note-block`);
      if ($shippingNote.length) {
        $shippingNote.appendTo(".biscuits-bundle-summary");
      }

      $(`${prodInfoContainerClass} .product-about`).appendTo($shippingNote);
    }
  })();
});
